/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Vuelidate from "vuelidate";
import firebase from "firebase/app";
import "firebase/firestore";
import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
// import "@progress/kendo-theme-bootstrap/scss/all.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import { Grid, GridInstaller } from "@progress/kendo-grid-vue-wrapper";
import { DataSourceInstaller } from "@progress/kendo-datasource-vue-wrapper";
import Vuetify from "vuetify/lib";
import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: [
    "fullscreen=yes",
    "titlebar=yes",
    "scrollbars=yes",
    "top=500",
    "left=150"
  ],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css",
    "https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css"
  ]
};
Vue.use(VueHtmlToPaper, options);

Vue.use(Vuetify);

import {
  ContextMenu,
  LayoutInstaller
} from "@progress/kendo-layout-vue-wrapper";

import vuetify from "./plugins/vuetify";

Vue.use(GridInstaller);
Vue.use(LayoutInstaller);
Vue.use(DataSourceInstaller);
Vue.use(Vuelidate);

require("dotenv").config();

var firebaseConfig = {
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_ID,
  measurementId: process.env.VUE_APP_MEASUREMENT_ID
};

firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  firebase,
  render: h => h(App),

  components: {
    Grid
  },

  vuetify,

  created() {
    this.$store.commit("setLoading", true);
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.dispatch("autoSignIn", user);
        // this.$router.push("/dashboard");
        this.$store.commit("setLoading", false);
      } else {
        this.$store.commit("setLoading", false);
      }
    });
  }
}).$mount("#app");

export const db = firebase.firestore();
